import accountMdl from "./account.mdl";
import settingMdl from "./setting.mdl";
import stockModuleSettingMdl from "./stockModuleSetting.mdl";

export default [
  ...accountMdl,
  ...settingMdl,
  ...stockModuleSettingMdl,
];
